import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  constructor(
    private meta: Meta,
    private title: Title
  ) { }

  /**
   * Met à jour les meta tags pour la page d'accueil
   */
  updateHomeMeta(): void {
    this.title.setTitle('BSTP | Bourse des Sous-Traitance et de Partenariats de Guinée');
    
    this.meta.updateTag({ name: 'description', content: 'La BSTP Guinée s\'engage à promouvoir le contenu local en habilitant les entreprises guinéennes à réaliser leur plein potentiel. Nous offrons un accès aux opportunités d\'affaires, un renforcement des capacités, des solutions de financement et la création de partenariats.' });
    
    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'BSTP | Bourse des Sous-Traitance et de Partenariats de Guinée' });
    this.meta.updateTag({ property: 'og:description', content: 'La BSTP Guinée s\'engage à promouvoir le contenu local en habilitant les entreprises guinéennes à réaliser leur plein potentiel.' });
    this.meta.updateTag({ property: 'og:image', content: 'https://storage.bstpgn.com/upload/brand/LOGO_BSTP.png' });
    this.meta.updateTag({ property: 'og:url', content: 'https://bstpgn.com/' });
    
    // Twitter
    this.meta.updateTag({ property: 'twitter:title', content: 'BSTP | Bourse des Sous-Traitance et de Partenariats de Guinée' });
    this.meta.updateTag({ property: 'twitter:description', content: 'La BSTP Guinée s\'engage à promouvoir le contenu local en habilitant les entreprises guinéennes à réaliser leur plein potentiel.' });
    this.meta.updateTag({ property: 'twitter:image', content: 'https://storage.bstpgn.com/upload/brand/LOGO_BSTP.png' });
    this.meta.updateTag({ property: 'twitter:url', content: 'https://bstpgn.com/' });
  }

  /**
   * Met à jour les meta tags pour la page du directeur exécutif
   */
  updateDirectorMeta(): void {
    this.title.setTitle('Mot du Directeur Exécutif | BSTP Guinée');
    
    this.meta.updateTag({ name: 'description', content: 'Découvrez le message et la vision de Saifoulaye BALDE, Directeur Exécutif de la BSTP Guinée. Son engagement pour le développement économique de la Guinée à travers les partenariats et la sous-traitance.' });
    
    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'Mot du Directeur Exécutif | BSTP Guinée' });
    this.meta.updateTag({ property: 'og:description', content: 'Découvrez le message et la vision de Saifoulaye BALDE, Directeur Exécutif de la BSTP Guinée. Son engagement pour le développement économique de la Guinée.' });
    this.meta.updateTag({ property: 'og:image', content: 'https://bstpgn.com/assets/img/directeur-executif/saifoulaye-balde.jpeg' });
    this.meta.updateTag({ property: 'og:url', content: 'https://bstpgn.com/mot-du-directeur-executif' });
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    
    // Twitter
    this.meta.updateTag({ property: 'twitter:title', content: 'Mot du Directeur Exécutif | BSTP Guinée' });
    this.meta.updateTag({ property: 'twitter:description', content: 'Découvrez le message et la vision de Saifoulaye BALDE, Directeur Exécutif de la BSTP Guinée. Son engagement pour le développement économique de la Guinée.' });
    this.meta.updateTag({ property: 'twitter:image', content: 'https://bstpgn.com/assets/img/directeur-executif/saifoulaye-balde.jpeg' });
    this.meta.updateTag({ property: 'twitter:url', content: 'https://bstpgn.com/mot-du-directeur-executif' });
    this.meta.updateTag({ property: 'twitter:card', content: 'summary_large_image' });
    
    // Additional meta tags
    this.meta.updateTag({ name: 'keywords', content: 'Directeur Exécutif, BSTP, Saifoulaye BALDE, Guinée, développement économique, partenariats, sous-traitance' });
    this.meta.updateTag({ name: 'author', content: 'Saifoulaye BALDE - Directeur Exécutif BSTP' });
  }

  /**
   * Met à jour les meta tags pour la page des missions
   */
  updateMissionsMeta(): void {
    this.title.setTitle('Missions de la BSTP | Développement Économique Guinée');
    
    this.meta.updateTag({ name: 'description', content: 'Découvrez les missions fondamentales de la BSTP Guinée : faciliter les partenariats, promouvoir la sous-traitance, stimuler l\'innovation et créer de l\'emploi durable.' });
    
    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'Missions de la BSTP | Développement Économique Guinée' });
    this.meta.updateTag({ property: 'og:description', content: 'Découvrez les missions fondamentales de la BSTP Guinée : faciliter les partenariats, promouvoir la sous-traitance, stimuler l\'innovation et créer de l\'emploi durable.' });
    this.meta.updateTag({ property: 'og:image', content: 'https://bstpgn.com/assets/img/bstp-missions.png' });
    this.meta.updateTag({ property: 'og:url', content: 'https://bstpgn.com/missions' });
    
    // Twitter
    this.meta.updateTag({ property: 'twitter:title', content: 'Missions de la BSTP | Développement Économique Guinée' });
    this.meta.updateTag({ property: 'twitter:description', content: 'Découvrez les missions fondamentales de la BSTP Guinée : faciliter les partenariats, promouvoir la sous-traitance, stimuler l\'innovation et créer de l\'emploi durable.' });
    this.meta.updateTag({ property: 'twitter:image', content: 'https://bstpgn.com/assets/img/bstp-missions.png' });
    this.meta.updateTag({ property: 'twitter:url', content: 'https://bstpgn.com/missions' });
    
    // Additional meta tags
    this.meta.updateTag({ name: 'keywords', content: 'Missions BSTP, partenariats, sous-traitance, innovation, emploi, développement économique, Guinée' });
  }

  /**
   * Met à jour les meta tags pour la page À propos
   */
  updateAboutMeta(): void {
    this.title.setTitle('À Propos de la BSTP | Histoire et Vision');
    
    this.meta.updateTag({ name: 'description', content: 'Découvrez l\'histoire, la mission et la vision de la BSTP Guinée. Notre engagement pour le développement économique et l\'autonomisation des entreprises guinéennes.' });
    
    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'À Propos de la BSTP | Histoire et Vision' });
    this.meta.updateTag({ property: 'og:description', content: 'Découvrez l\'histoire, la mission et la vision de la BSTP Guinée. Notre engagement pour le développement économique et l\'autonomisation des entreprises guinéennes.' });
    this.meta.updateTag({ property: 'og:image', content: 'https://bstpgn.com/assets/img/bstp-about.png' });
    this.meta.updateTag({ property: 'og:url', content: 'https://bstpgn.com/about' });
    
    // Twitter
    this.meta.updateTag({ property: 'twitter:title', content: 'À Propos de la BSTP | Histoire et Vision' });
    this.meta.updateTag({ property: 'twitter:description', content: 'Découvrez l\'histoire, la mission et la vision de la BSTP Guinée. Notre engagement pour le développement économique et l\'autonomisation des entreprises guinéennes.' });
    this.meta.updateTag({ property: 'twitter:image', content: 'https://bstpgn.com/assets/img/bstp-about.png' });
    this.meta.updateTag({ property: 'twitter:url', content: 'https://bstpgn.com/about' });
    
    // Additional meta tags
    this.meta.updateTag({ name: 'keywords', content: 'À propos BSTP, histoire, mission, vision, développement économique, Guinée, entreprises' });
  }

  /**
   * Met à jour les meta tags pour la page Contact
   */
  updateContactMeta(): void {
    this.title.setTitle('Contact BSTP | Nous Contacter');
    
    this.meta.updateTag({ name: 'description', content: 'Contactez la BSTP Guinée. Notre équipe est disponible pour répondre à vos questions et vous accompagner dans vos projets de développement économique.' });
    
    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'Contact BSTP | Nous Contacter' });
    this.meta.updateTag({ property: 'og:description', content: 'Contactez la BSTP Guinée. Notre équipe est disponible pour répondre à vos questions et vous accompagner dans vos projets de développement économique.' });
    this.meta.updateTag({ property: 'og:image', content: 'https://bstpgn.com/assets/img/bstp-contact.png' });
    this.meta.updateTag({ property: 'og:url', content: 'https://bstpgn.com/contact' });
    
    // Twitter
    this.meta.updateTag({ property: 'twitter:title', content: 'Contact BSTP | Nous Contacter' });
    this.meta.updateTag({ property: 'twitter:description', content: 'Contactez la BSTP Guinée. Notre équipe est disponible pour répondre à vos questions et vous accompagner dans vos projets de développement économique.' });
    this.meta.updateTag({ property: 'twitter:image', content: 'https://bstpgn.com/assets/img/bstp-contact.png' });
    this.meta.updateTag({ property: 'twitter:url', content: 'https://bstpgn.com/contact' });
    
    // Additional meta tags
    this.meta.updateTag({ name: 'keywords', content: 'Contact BSTP, adresse, téléphone, email, Guinée, Conakry' });
  }

  /**
   * Met à jour les meta tags pour une page personnalisée
   */
  updateCustomMeta(
    title: string,
    description: string,
    image: string = 'https://storage.bstpgn.com/upload/brand/LOGO_BSTP.png',
    url: string = 'https://bstpgn.com/',
    keywords: string = 'BSTP, Guinée, développement économique'
  ): void {
    this.title.setTitle(title);
    
    this.meta.updateTag({ name: 'description', content: description });
    
    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:image', content: image });
    this.meta.updateTag({ property: 'og:url', content: url });
    
    // Twitter
    this.meta.updateTag({ property: 'twitter:title', content: title });
    this.meta.updateTag({ property: 'twitter:description', content: description });
    this.meta.updateTag({ property: 'twitter:image', content: image });
    this.meta.updateTag({ property: 'twitter:url', content: url });
    
    // Additional meta tags
    this.meta.updateTag({ name: 'keywords', content: keywords });
  }
} 